import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const maskOptions = {
    prefix: '',
    suffix: '', 
    includeThousandsSeparator: false,
    allowDecimal: false,
    integerLimit: 8,
    allowNegative: false,
    allowLeadingZeroes: false,
};

function TextMaskInteger(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={createNumberMask(maskOptions)}
            placeholderChar={'\u2000'}
        />
    );
}
TextMaskInteger.propTypes = {
    inputRef: PropTypes.func.isRequired,
};

export default TextMaskInteger;